module.exports = __webpack_public_path__ + "static/img/A39.3d1f75ed.jpg";